import { api } from './authService';
import { audit } from './endpoints';
import { constructUrl } from '../utils/construct-url';
import { getParams } from '../utils/get-param-util';
import { AuditLogSchema, TGetAuditLogsParams, TGetAuditLogsResponse } from '../types/audit-log';

export const getAuditLogs = async (
  params: TGetAuditLogsParams = {}
): Promise<TGetAuditLogsResponse> => {
  const query = getParams<Partial<TGetAuditLogsParams>>(params);
  const url = constructUrl(audit.getAuditLogs, query);
  const response = await api.get<TGetAuditLogsResponse>(url);
  return response.data;
};

export const getAuditLogById = async (id: string): Promise<AuditLogSchema> => {
  const response = await api.get<AuditLogSchema>(audit.getAuditLogById(id));
  return response.data;
};


